// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes circular-animation-067efbbc{to{stroke-dashoffset:0}}.tutorial-guide-section[data-v-067efbbc] .guide-section-component .section-head h2{color:#000;font-size:40px}@media only screen and (max-width:768px){.tutorial-guide-section[data-v-067efbbc] .guide-section-component .section-head h2{font-size:32px;text-align:left}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
